import { Button, Group, Modal } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

interface PhysicalExamDeleteModalProps {
  opened: boolean;
  onClose: () => void;
  onDelete: (e: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
}

export default function PhysicalExamDeleteModal({
  opened,
  onClose,
  onDelete,
}: PhysicalExamDeleteModalProps) {
  return (
    <Modal.Root opened={opened} onClose={onClose}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title variant="bold">Are you sure you want to delete?</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <TextWrapper mt="xs" mb="lg" size="sm">
            Performing this action will permanently delete this Physical Exam.
          </TextWrapper>
          <Group gap="md" align="center" justify="flex-end">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button color="red.9" onClick={onDelete}>
              Yes, Delete
            </Button>
          </Group>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}
